import Layout from "../../layout/main";
import StackKit from "@/shared/components/kit/stack";
import Support from "../../components/support";
import { Outlet, useLocation } from "react-router";
/**
 * SupportPage
 *
 * صفحه پشتیبانی کاربران. در صورت مسیر دقیق "/support"، کامپوننت Support را نمایش می‌دهد و در غیر این صورت، Outlet برای مسیرهای فرزند رندر می‌شود.
 *
 * @returns JSX.Element
 */

// Task Response:

// کد شما درست است و ساختار مناسبی برای رندر Support یا Outlet بر اساس مسیر دارد.
// نکته: اگر مسیرهای فرزند زیادی دارید، می‌توان بررسی مسیر را با useMatch ساده‌تر کرد.

const SupportPage = () => {
  const location = useLocation();

  const isExactCreditsPage = location.pathname === "/support";

  return (
    <Layout>
      <StackKit direction={"column"} sx={{width: "100%",maxWidth: "1740px",gap: 10,}}>
        {isExactCreditsPage ? <Support /> : <Outlet />}
      </StackKit>
    </Layout>
  );
};

export default SupportPage;
